// extracted by mini-css-extract-plugin
export default {"container":"jM-z","error":"kM-z","disabled":"lM-z","submit":"mM-z","option":"nM-z","success":"oM-z","failure":"pM-z"};